var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizardIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0999 21.5832C6.8072 21.5832 2.5166 17.2925 2.5166 11.9998C2.5166 6.70711 6.8072 2.4165 12.0999 2.4165C17.3926 2.4165 21.6833 6.70711 21.6833 11.9998C21.6833 17.2925 17.3926 21.5832 12.0999 21.5832ZM9.90537 19.3478C8.98289 17.3913 8.41737 15.2334 8.29277 12.9582H4.49258C4.87219 16.0023 7.03648 18.4923 9.90537 19.3478ZM10.2127 12.9582C10.3568 15.2954 11.0245 17.4908 12.0999 19.4288C13.1754 17.4908 13.843 15.2954 13.9872 12.9582H10.2127ZM19.7073 12.9582H15.9071C15.7825 15.2334 15.217 17.3913 14.2945 19.3478C17.1634 18.4923 19.3277 16.0023 19.7073 12.9582ZM4.49258 11.0415H8.29277C8.41737 8.7662 8.98289 6.60832 9.90537 4.65187C7.03648 5.50745 4.87219 7.99736 4.49258 11.0415ZM10.2127 11.0415H13.9872C13.843 8.70434 13.1754 6.50883 12.0999 4.57083C11.0245 6.50883 10.3568 8.70434 10.2127 11.0415ZM14.2945 4.65187C15.217 6.60832 15.7825 8.7662 15.9071 11.0415H19.7073C19.3277 7.99736 17.1634 5.50745 14.2945 4.65187Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardIcon04);
export default __webpack_public_path__ + "static/media/wizard-icon-04.4281867b79da05a259ff059e6766d828.svg";
export { ForwardRef as ReactComponent };